import React from 'react';
import Text from '@amzn/meridian/text';

interface TextContentProps {
  content: string;
}

const TextContent: React.FC<TextContentProps> = ({content}) => (
  <Text tag='ul'>
    <li>{content}</li>
  </Text>
);

export default TextContent;
